import { createFileRoute } from "@tanstack/react-router";
import { AdminCrawlerPerformancePage } from "@/components/admin/pages/AdminCrawlerPerformancePage";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/performance")({
  component: AdminCrawlerPerformancePage,
});
